import React from 'react';
import { motion } from 'framer-motion';
import { Button } from "../ui/Button";
import { ArrowRight } from 'lucide-react';

export const CallToAction: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2 
            className="text-3xl md:text-4xl font-bold mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Ready to Automate Your Crypto Trading?
          </motion.h2>
          
          <motion.p 
            className="text-lg md:text-xl mb-8 text-white/90"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Join thousands of traders who are already using BOTINO.NET to automate their trading strategies.
            Start for free and upgrade as your portfolio grows.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <Button 
              size="lg"
              className="bg-white text-blue-600 hover:bg-gray-100 shadow-xl"
            >
              Sign Up Now
            </Button>
            
            <Button 
              variant="ghost" 
              size="lg"
              className="text-white border-white hover:bg-white/10"
              icon={<ArrowRight size={18} />}
              iconPosition="right"
            >
              Schedule a Demo
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};